import axios from "axios";
import axiosInstance from "../api/axiosInstance";
import { getAuthToken } from "./authService";

const AUTH_API_URL = process.env.REACT_APP_AUTH_SERVICE_URL || "http://localhost:8081";

const getAuthHeaders = () => {
    const token = getAuthToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// --- AUTH APP CALLS (Port 8081) ---

export const updateAuthProfile = async (name, email) => {
    try {
        const response = await axios.put(`${AUTH_API_URL}/api/user/profile`, JSON.stringify({ name, email }), {
            headers: { "Content-Type": "application/json", ...getAuthHeaders() }
        });
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: error.response?.data?.message || error.message };
    }
};

export const updatePassword = async (newPassword) => {
    try {
        const response = await axios.put(`${AUTH_API_URL}/api/user/password`, JSON.stringify({ password: newPassword }), {
            headers: { "Content-Type": "application/json", ...getAuthHeaders() }
        });
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: error.response?.data?.message || error.message };
    }
};

// --- HOMEBOX APP CALLS (Port 8082) ---

export const fetchProfileDetails = async () => {
    try {
        const response = await axiosInstance.get("/api/profile");
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const updateBio = async (bio) => {
    try {
        const response = await axiosInstance.put("/api/profile/bio", { bio });
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const uploadProfileImage = async (formData) => {
    try {
        const response = await axiosInstance.post("/api/profile/image", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: error.message };
    }
};
